import { render, staticRenderFns } from "./GlassItem.vue?vue&type=template&id=353299f1&scoped=true"
import script from "./GlassItem.vue?vue&type=script&lang=js"
export * from "./GlassItem.vue?vue&type=script&lang=js"
import style0 from "./GlassItem.vue?vue&type=style&index=0&id=353299f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353299f1",
  null
  
)

export default component.exports